// describeUserAgent — a browser's User-Agent string as a person would name the device:
// "Chrome on Android", "Safari on iPhone", "Firefox on Windows".
//
// The device lists showed the raw string ("Mozilla/5.0 (Linux; Android 10; K) AppleWebKit/537.36
// (KHTML, like Gecko) Chrome/141…"), which nobody can read and which overflowed every card it sat
// in (measured 2026-11-02). The raw string is still the source and is kept for whoever needs it
// (behind technical details); this is only its name.
export function describeUserAgent(ua: string | null | undefined): string {
  if (!ua) return "Unknown device";
  const s = ua;
  const os = /iPhone/.test(s)
    ? "iPhone"
    : /iPad/.test(s)
      ? "iPad"
      : /Android/.test(s)
        ? "Android"
        : /Windows/.test(s)
          ? "Windows"
          : /CrOS/.test(s)
            ? "ChromeOS"
            : /Mac OS X|Macintosh/.test(s)
              ? "Mac"
              : /Linux/.test(s)
                ? "Linux"
                : "";
  const browser = /SamsungBrowser\//.test(s)
    ? "Samsung Internet"
    : /EdgA?\/|Edg\//.test(s)
      ? "Edge"
      : /OPR\/|Opera/.test(s)
        ? "Opera"
        : /FxiOS\/|Firefox\//.test(s)
          ? "Firefox"
          : /CriOS\/|Chrome\//.test(s)
            ? "Chrome"
            : /Safari\//.test(s) && /Version\//.test(s)
              ? "Safari"
              : /AppleWebKit/.test(s) && (os === "iPhone" || os === "iPad")
                ? "Home-screen app"
                : "";
  if (browser && os) return `${browser} on ${os}`;
  if (browser || os) return browser || os;
  // Not a browser at all (a mail app reports its own name): show it as it came, shortened.
  return s.length > 40 ? s.slice(0, 40) + "…" : s;
}
